import { GetPropertyByIdQuery } from 'gql/generated.graphql';
import min from 'lodash/min';
import camelCase from 'lodash/camelCase';

const formatBuildingTypes = (
  buildingTypesCount: Record<string, number>,
  t: Function
) =>
  Object.entries(buildingTypesCount)
    .map(
      ([key, value]: any) =>
        `${value}+ ${t(
          `forms:labels.buildingTypes.${camelCase(key)}`
        ).toLowerCase()}`
    )
    .join(', ');

const getBuildingTypesCounts = (
  properties: (GetPropertyByIdQuery['getPropertyById'] | undefined)[]
) =>
  properties.reduce((memo: Record<string, number>, item) => {
    item?.buildingTypes?.forEach((type) => {
      memo[type] = memo[type] ? memo[type] + 1 : 1;
    });
    return memo;
  }, {});

export const getPropertiesDataToView = (
  properties: GetPropertyByIdQuery['getPropertyById'][],
  t: Function
) => {
  const minPrice = min(properties.map((item) => item?.priceRange?.min));

  const propertyToView = properties.find(
    (item) => item?.priceRange?.min === minPrice
  );

  const buildingTypesCount = getBuildingTypesCounts(properties);
  const buildingTypesText = formatBuildingTypes(buildingTypesCount, t);

  return {
    buildingTypesText,
    propertyToView,
  };
};
